import htmlLegendPlugin from './htmlLegendPlugin';
import customDoubleClick from './customDoubleClick';

const externalPlugins = [
	htmlLegendPlugin,
	customDoubleClick,
	// customCanvasBackgroundColor
];

export default externalPlugins;